export enum OrderReturnJustification {
  STOCK_BURST = 'STOCK_BURST',
  INVALID_QMV = 'INVALID_QMV',
  NO_SYSTEM = 'NO_SYSTEM',
  RESEND = 'RESEND',
  SIMILAR_ITEM = 'SIMILAR_ITEM',
  LOGISTICS_OPTIMIZATION = 'LOGISTICS_OPTIMIZATION',
  //To reason equal PRODUCT_PROBLEM
  DEFECTIVE_PRODUCT = 'DEFECTIVE_PRODUCT',
  PRODUCT_DIFFERENT = 'PRODUCT_DIFFERENT',
  PRODUCT_INCOMPLETE_OR_MISSING_PARTS = 'PRODUCT_INCOMPLETE_OR_MISSING_PARTS',
  APPLICATION_ERROR = 'APPLICATION_ERROR',
  WARRANTY = 'WARRANTY',
  //To reason equal LATE_DELIVERY
  ORDER_ARRIVED_LATE = 'ORDER_ARRIVED_LATE',
  ORDER_NOT_DELIVERED = 'ORDER_NOT_DELIVERED',
  MISSING_ITEM_FROM_ORDER = 'MISSING_ITEM_FROM_ORDER',
  //To reason equal CHANGED_MIND
  NO_LONGER_NEED_PRODUCT = 'NO_LONGER_NEED_PRODUCT',
  PURCHASE_REGRET = 'PURCHASE_REGRET',
  //Cancel reason
  COMMERCIAL_REQUEST = 'COMMERCIAL_REQUEST',
  PRICE_DIFFERENCE = 'PRICE_DIFFERENCE',
  ANOMALOUS_MARGIN = 'ANOMALOUS_MARGIN',
  OUT_OF_STOCK = 'OUT_OF_STOCK',
}
